import SpinnerPage from '../general/spinner-page';
import PaymentError from './payment-error';
import PaymentPaid from './payment-paid';
import PaymentStart from './payment-start';
import PaymentCancel from './payment-cancel';
import PaymentCredit from './payment-credit';

module.exports = {
  SpinnerPage: SpinnerPage,
  PaymentError: PaymentError,
  PaymentPaid: PaymentPaid,
  PaymentStart: PaymentStart,
  PaymentCancel: PaymentCancel,
  PaymentCredit: PaymentCredit
};



/** WEBPACK FOOTER **
 ** ./src/views/payment/index.js
 **/